import { Select, Row, Col, message } from 'antd';
import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import axios from '../../util/Api';

const ProjectSelect = () => {
  const formik = useFormikContext();
  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = () => {
    setLoading(true);
    const url = `/project/options`;
    axios.get(url, { params: { sort: 'status' } }).then(({ data }) => {
      setProjects(data.projects);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat daftar proyek");
    });
  }
  return (
    <Select
      showSearch
      loading={loading}
      defaultValue={formik.values.project}
      onChange={(value) => formik.setFieldValue("project", value)}
      style={{ width: 320 }}
      placeholder="Pilih proyek"
      optionFilterProp="label"
    >
      {projects.map((prj, key) => {
        return <Select.Option value={prj.id} key={`project-${key}`} label={prj.name}>
          <Row>
            <Col span={12}>
              {prj.name}
              <div>
                {prj.code} - {prj.division.label}
              </div>
            </Col>
            <Col span={12} className="gx-text-right">{prj.status.label}</Col>
          </Row>
        </Select.Option>
      })}
    </Select>
  );
}
export default ProjectSelect;